<template>
  <div class="" >

    <div :class="(show)?'modal fade show':'modal fade '" v-bind:style="{'display':(show)?'block':'none'}" id="mediumModal" tabindex="-1" role="dialog" aria-labelledby="mediumModalLabel" aria-hidden="true">
      <div class="modal-dialog modal-lg" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="mediumModalLabel">{{msgTitle}} {{ $t("modal."+tmsgTitle) }}</h5>
            <button type="button" class="close" data-dismiss="modal" :aria-label="$t('close')"  v-on:click="fnCancel">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <p>
              {{msgText}}
              <template v-if="tmsgText">
                {{ $t("modal."+tmsgText) }}
              </template>
            </p>
          </div>
          <div class="modal-footer">
            <template v-if="type==='confirm'">
              <button type="button" class="btn btn-secondary" data-dismiss="modal" v-on:click="fnCancel">{{$t('modal.cancel')}}</button>
              <button type="button" class="btn btn-primary defaultModalButton" v-on:click="fnConfirm">{{$t('modal.ok')}}</button>
            </template>
          </div>
        </div>
      </div>
    </div>
    <div :class="(show)?'modal-backdrop fade show':''" v-on:click="fnCancel"></div>

  </div>
</template>

<script>
  export default {
    name: 'Modal',
    data(){
      return {
        show: false,
        type: "",
        msgTitle: "",
        tmsgTitle: "",
        msgText: "",
        tmsgText: "",
        fnCancel: function () {
        },
        fnConfirm: function () {
        },
//        , delay: 4000
      }
    },
    mounted() {
      console.log("Modal");
      const modul = this;
      modul.$eventBus.$on('modal', this.modalEventHandler);
    },
    beforeDestroy() {
      this.$eventBus.$off('modal');
    },
    props: {
//      type: String, // confirm
//      msg: String,
//      msgPre: {
//        type: String,
//        default: "",
//      },
//      msgPost: {
//        type: String,
//        default: "",
//      },
//      delay: Number,
    },
    watch: {
      msg: function (newmsg, oldmsg) {
        console.log("Modal - run")
        const modul = this;
//        if (newmsg.length > 0) {
//          modul.display = "block"
//        } else {
//          modul.display = "none"
//        }
//        if (newmsg.length === 0) {
//          modul.msgPreInner = "";
//          modul.msgPostInner = "";
//        }
      },

    },
    methods: {
      modalEventHandler: function (obj) {
        const modul = this;
        if (obj && obj.type) {
          modul.show = true;
          modul.type = obj.type;
          modul.msgTitle = (obj.msgTitle)?obj.msgTitle:"";
          modul.tmsgTitle = (obj.tmsgTitle)?obj.tmsgTitle:"";
          modul.msgText = (obj.msgText)?obj.msgText:"";
          modul.tmsgText = (obj.tmsgText)?obj.tmsgText:"";
          modul.fnCancel = function () {
            modul.show = false
            obj.fnCancel();
          };
          modul.fnConfirm = function () {
            modul.show = false
            obj.fnConfirm();
          };

          setTimeout(function () {
            const e =document.getElementsByClassName("defaultModalButton")[0];
            if(e && e.focus){
                e.focus();
            }
          })
        }
      },
      something(e){
        return e;
      },
    }

  };
</script>

<style>

</style>


